"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.view = void 0;
var UrlGetter_1 = require("../../shared/code/UrlGetter");
var mapping_1 = require("../../mapping");
var csod = require("player-core");
var constants = require("../../shared/code/Constants");
var SpinnerController_1 = require("../../shared/code/SpinnerController");
function view() {
    var _this = this;
    var USER_GUID = "USER.GUID";
    var JOB_REQUISITION_ID = "JOB.REQUISITION.ID";
    var isThankYouPageDefault = function (actionItem) {
        return isStringEmpty(actionItem.note) && isStringEmpty(actionItem.instructions) && isStringEmpty(actionItem.title);
    };
    var isStringEmpty = function (str) {
        return !str || str.length == 0;
    };
    var containsTags = function (msg) {
        return msg != null && (msg.indexOf(USER_GUID) > -1 || msg.indexOf(JOB_REQUISITION_ID) > -1);
    };
    function initThankYouDefaultFields(actionItem, successText, jobDetailUrl, jobTitle, thankYouText, reqId, userId, resolve) {
        var defaultNote = successText + "<a href=\"" + jobDetailUrl + "\">" + jobTitle + "</a>";
        if (isThankYouPageDefault(actionItem)) {
            actionItem.title = thankYouText;
            actionItem.note = defaultNote;
            csod.viewModel.isLoading = false;
            SpinnerController_1.SpinnerController.off(true);
            resolve();
        }
        else if (containsTags(actionItem.note) || containsTags(actionItem.instructions)) {
            actionItem.title = thankYouText;
            var promises = [];
            if (containsTags(actionItem.note)) {
                promises.push(mapping_1.getResolvedTags(userId, parseInt(reqId), actionItem.note));
            }
            if (containsTags(actionItem.instructions)) {
                promises.push(mapping_1.getResolvedTags(userId, parseInt(reqId), actionItem.instructions));
            }
            Promise.all(promises)
                .then(function (values) {
                if (values.length == 2) {
                    if (values[0] == null || values[1] == null) {
                        actionItem.note = defaultNote;
                        actionItem.instructions = '';
                    }
                    else {
                        actionItem.note = values[0];
                        actionItem.instructions = values[1];
                    }
                }
                else {
                    if (values[0] == null) {
                        actionItem.note = defaultNote;
                        actionItem.instructions = '';
                    }
                    else if (containsTags(actionItem.note)) {
                        actionItem.note = values[0];
                    }
                    else {
                        actionItem.instructions = values[0];
                    }
                }
                SpinnerController_1.SpinnerController.off(true);
                resolve();
            })
                .catch(function (error) {
                csod.logger.error('Unable to resolve tags' + error);
                SpinnerController_1.SpinnerController.off(true);
                resolve();
            });
        }
        else {
            SpinnerController_1.SpinnerController.off(true);
            resolve();
        }
    }
    function shouldShowLinkedInConversion() {
        return (csod.viewModel.applyWithLinkedInData.isEnabled && csod.viewModel.applyWithLinkedInData.didApplicantApplyWithLinkedIn);
    }
    return {
        state: {
            actionItem: this.props.actionItem,
            image: csod.context.basePath + "assets/thank_you.png",
            parentTag: "",
            isDefaultImageVisible: true,
            backToSearchUrl: '',
            jobDetailUrl: '',
            isCareerSiteResponsive: this.props.isCareerSiteResponsive,
            isCreateProfileVisible: this.props.showProfileButton || csod.viewModel.isPreview,
            areButtonsEnabled: !csod.viewModel.isPreview,
            applyWithLinkedInShowConversionWidget: shouldShowLinkedInConversion(),
            applyWithLinkedInApiKey: csod.viewModel.applyWithLinkedInData.apiKey,
            applyWithLinkedInIntegrationContext: csod.viewModel.applyWithLinkedInData.integrationContext,
            constants: constants
        },
        initialize: function () {
            return new Promise(function (resolve) {
                SpinnerController_1.SpinnerController.on(true);
                _this.view.state.parentTag = _this.view.state.actionItem.type + "-" + _this.view.state.actionItem.id;
                _this.view.state.isDefaultImageVisible = isThankYouPageDefault(_this.view.state.actionItem);
                _this.view.state.backToSearchUrl = UrlGetter_1.UrlGetter.createBackToSearchUrl(_this.view.state.isCareerSiteResponsive, _this.props.reqId, _this.props.careerSiteId, _this.props.isCareerCenter, _this.props.searchQueryParameters, csod.viewModel.cultureName);
                _this.view.state.jobDetailUrl = UrlGetter_1.UrlGetter.createJobDetailsUrl(_this.view.state.isCareerSiteResponsive, _this.props.reqId, _this.props.careerSiteId, _this.props.isCareerCenter, _this.props.searchQueryParameters, csod.viewModel.cultureName);
                initThankYouDefaultFields(_this.view.state.actionItem, _this.props.successText, _this.view.state.jobDetailUrl, _this.props.jobTitle, _this.props.thankYouText, _this.props.reqId, csod.viewModel.userId, resolve);
            });
        },
        mounted: function () {
        },
        receivedProps: function (nextProps) {
            return new Promise(function (resolve) {
                resolve();
            });
        },
        unmount: function () {
        },
        events: {}
    };
}
exports.view = view;



//////////////////
// WEBPACK FOOTER
// C:/TeamCity/buildAgent2/work/8b1685a0cde68c49/src/.tmp/ApplicationWorkflowThankYou/View.js
// module id = 339
// module chunks = 0 2